import { PaywallInstance } from '@paywall/plugins/PaywallInstance';

function getCustomerProfile(state: PaywallInstance['state']) {
  const { subscription } = state;

  return subscription?.profile || null;
}

export default getCustomerProfile;
